import { Link } from "react-router-dom";
import { useLocale } from "@/i18n/LocaleProvider";

/* Footer: the legacy's single centred rights line, with a privacy link added
 * because the site now has a privacy page to link to. */
export function Footer() {
  const { t } = useLocale();
  return (
    <footer className="sq-footer">
      {/* The design's «SOUQAKAR · CAIRO» footer line, in Arabic on the Arabic
          page (amendment 5) and letter-spaced only in English. */}
      <div className="sq-eyebrow sq-footer__place">{t.home.footerPlace}</div>
      <div>{t.footer.rights}</div>
      <div className="sq-footer__links">
        <Link className="sq-footer__link" to="/privacy">{t.footer.privacy}</Link>
      </div>
    </footer>
  );
}
